import React from 'react';
import { UI_COLORS, colorHelpers } from '../../utils/colors';
import { useTranslation } from 'react-i18next';

/**
 * StockRevertChoice
 *
 * The either/or a delete needs once the record has already moved inventory: give the
 * stock back, or drop only the paperwork and leave every warehouse balance standing.
 * Rendered inside the delete confirmation dialogs, which accept a node as their
 * `message`.
 *
 * Props:
 * - value: true to revert the stock (the default), false to keep the balances
 * - onChange: receives the next boolean
 * - variant: 'single' for one order, 'bulk' for a whole selection — picks the wording
 * - name: radio group name, so two dialogs on one page cannot share a group
 */
const StockRevertChoice = ({ value = true, onChange, variant = 'single', disabled = false, name = 'revert-stock' }) => {
  const { t } = useTranslation();

  const options = [
    { key: 'revert', revertStock: true },
    { key: 'keep', revertStock: false },
  ];

  return (
    <div className="w-full">
      <p className="mb-2 font-semibold" style={{ color: UI_COLORS.TEXT.PRIMARY }}>
        {t(`stockRevert.${variant}.heading`)}
      </p>
      <div className="space-y-2">
        {options.map((option) => {
          const selected = value === option.revertStock;
          return (
            <label
              key={option.key}
              className="flex cursor-pointer items-start gap-3 rounded-xl border p-3 transition-all duration-200"
              style={{
                borderColor: selected ? UI_COLORS.BRAND.PRIMARY : UI_COLORS.BORDERS.LIGHT,
                backgroundColor: selected
                  ? colorHelpers.withOpacity(UI_COLORS.BRAND.PRIMARY, 0.08)
                  : 'transparent',
              }}
            >
              <input
                type="radio"
                name={name}
                className="mt-1 h-4 w-4 cursor-pointer"
                checked={selected}
                disabled={disabled}
                onChange={() => onChange?.(option.revertStock)}
              />
              <span className="text-left">
                <span className="block text-sm font-semibold" style={{ color: UI_COLORS.TEXT.PRIMARY }}>
                  {t(`stockRevert.${variant}.${option.key}Label`)}
                </span>
                <span className="mt-0.5 block text-xs" style={{ color: UI_COLORS.TEXT.SECONDARY }}>
                  {t(`stockRevert.${variant}.${option.key}Description`)}
                </span>
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default StockRevertChoice;
